import { applyTimeFilter as applyTimeFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type ApplyTimeFilterProps = ApiMethodBase & {
    fromTime: string,
    toTime: string,
    type?: string,
    mode?: string
}

export async function applyTimeFilter ({
    fromTime,
    toTime,
    type,
    mode,
    eventEmitter,
}: ApplyTimeFilterProps) {
    applyTimeFilterDiagram(fromTime, toTime, type);
    eventEmitter.emit(Event.applyFilter);
    if (mode === 'process_miner') apiProvider.setDiagramVisualizer()    
    if (mode === 'time_in_activity') eventEmitter.emit(Event.updateTimeInActivity);
    if (mode === 'decomposition_tree') {
        apiProvider.setAction_DecompositionTree({})
        apiProvider.setDiagramDecompositionTree({source: 'applyTasksFilter'})
    }
    if (mode === 'cluster_insights') {
        apiProvider.setAction_Cluster({})
        apiProvider.setDiagramCluster({source: 'applyTasksFilter'})
    }
    if (mode === 'influence_analysis') {
        apiProvider.setAction_InfluenceAnalysis({})
        apiProvider.setDiagramInfluenceAnalysis({source: 'applyTasksFilter'})
    }   
    eventEmitter.emit(Event.updateGaugeMetrics);
};
